import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ChainedBackend from "i18next-chained-backend";
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from "i18next-http-backend";

i18n
    .use(ChainedBackend)
    .use(LanguageDetector)
    .use(initReactI18next) // bind react-i18next to the instance
        .init({
            fallbackLng: 'en',
            lng: 'en',
            debug: true,
            interpolation: {
                escapeValue: false, // not needed for react as it escapes by default
            },
            react: {
                useSuspense:false
            },
            backend: {
                backends: [
                    HttpBackend
                ],
                backendOptions: [
                    {
                        expirationTime: 7 * 24 * 60 * 60 * 1000, // 7 days
                        versions: {en: 'v1.2211', he: 'v1.2211'} //when updating the translation files update the version, 'update translations'
                    },
                    {
                        loadPath: '/locales/{{lng}}/{{ns}}.json'
                    }
                ]
            }
        });

//this function is listening for changing language events.
i18n.on('languageChanged', function(lng) {

});

export default i18n;


